var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7AB9E8"
    },
    d: "M46.545,155.152C20.88,155.152,0,134.271,0,108.606s20.88-46.545,46.545-46.545 s46.545,20.88,46.545,46.545S72.211,155.152,46.545,155.152z M46.544,108.577l0.002,0.029 C46.545,108.586,46.544,108.577,46.544,108.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7AB9E8"
    },
    d: "M46.545,449.939C20.88,449.939,0,429.059,0,403.394c0-25.665,20.88-46.545,46.545-46.545 s46.545,20.88,46.545,46.545C93.091,429.059,72.211,449.939,46.545,449.939z M46.544,403.364l0.002,0.029 C46.545,403.374,46.544,403.364,46.544,403.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7AB9E8"
    },
    d: "M46.545,302.545C20.88,302.545,0,281.665,0,256s20.88-46.545,46.545-46.545 S93.091,230.335,93.091,256S72.211,302.545,46.545,302.545z M46.544,255.971L46.545,256 C46.545,255.98,46.544,255.971,46.544,255.971z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131.879,
    y: 232.727,
    style: {
      fill: "#88888F"
    },
    width: 380.121,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.879,
    y: 380.121,
    style: {
      fill: "#88888F"
    },
    width: 380.121,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.879,
    y: 85.333,
    style: {
      fill: "#88888F"
    },
    width: 380.121,
    height: 46.545
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 318.061,
    y: 232.727,
    style: {
      fill: "#56545A"
    },
    width: 193.939,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.061,
    y: 380.121,
    style: {
      fill: "#56545A"
    },
    width: 193.939,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.061,
    y: 85.333,
    style: {
      fill: "#56545A"
    },
    width: 193.939,
    height: 46.545
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#579ADF"
    },
    d: "M46.545,209.455v93.091c25.665,0,46.545-20.88,46.545-46.545S72.211,209.455,46.545,209.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#579ADF"
    },
    d: "M46.545,155.152c25.665,0,46.545-20.88,46.545-46.545s-20.88-46.545-46.545-46.545V155.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#579ADF"
    },
    d: "M46.545,356.848v93.091c25.665,0,46.545-20.88,46.545-46.545 C93.091,377.729,72.211,356.848,46.545,356.848z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.648772f930824b445102363099f3daa4.svg";
export { ForwardRef as ReactComponent };